import { createStore } from "vuex";

export default createStore({
  state: {
    webSocketClient: null, // websocket 实例
    ambulanceLists: [], //  返回急救车列表 (包括无人车无人机)
    carObject: {}, // 储存急救车id以及对应的急救车名称
    carPlate: {}, // 储存急救车id以及对应的车牌号
    // patientlist: [], // 返回所有病人的事例
    currentList: [], //  返回正在出车的病人list
    hospitalName: "", // 储存急救车name
    hospitalID: "", // 储存急救车ID
    hospitalInfo: {}, // 医院相关信息
    userInfo: {}, // 用户信息
    assistMessage: [], // 邀请协助的信息
    allPosition: {}, // 所有地图的gps定位
    showOrEditPatientInfo: {}, // 信息管理事例查看页面的信息
    isCollapseAside: false, // 收缩侧边栏
    tencentRoomStatus: {}, // 打开的房间
    visitedViews: [ // 储存点击到的侧边栏
      // {
      //   fullPath: "/HelpBeforeArrival",
      //   name: "Dash",
      //   path: "/HelpBeforeArrival",
      //   title: "首页"
      // }
    ],
  },
  mutations: {
    deleteData(state) {
      state.ambulanceLists = [];
      state.webSocketClient = null;
      state.assistMessage = [];
      // state.patientlist = null;
      state.currentList = [];
      state.hospitalInfo = {};
      state.tencentRoomStatus = {};
      state.visitedViews = [];
      state.showOrEditPatientInfo = {};
    },
    /*
    *  是否收缩侧边栏
    * */
    updateCollapseAside(state, isCollapse) {
      state.isCollapseAside = isCollapse;
    },
    updateAssistMessage(state, assistMessage) {
      state.assistMessage = assistMessage;
    },
    updateWebSocketClient(state, client) {
      state.webSocketClient = client;
    },
    updateCarList(state, carlist) {
      state.ambulanceLists = [];
      state.ambulanceLists = carlist;
    },
    // 更新TRTC房间号
    updateTencentRoomStatus(state, rooms) {
      rooms.forEach(room => {
        state.tencentRoomStatus[room.roomId] = room.status;
      });
      console.log(state.tencentRoomStatus);
    },
    updateCarObject(state, carObject) {
      state.carObject = {};
      state.carObject = carObject;
    },
    updateCarPlate(state, carPlate) {
      state.carPlate = {};
      state.carPlate = carPlate;
    },
    // updatePatientList(state, patientlist) {
    //   state.patientlist = [];
    //   state.patientlist = patientlist;
    // },
    updateCurrentList(state, currentList) {
      // console.log(currentList);
      state.currentList = [];
      state.currentList = currentList;
    },
    updateHospitalName(state, name) {
      state.hospitalName = name;
    },
    updateHospitalID(state, id) {
      state.hospitalID = id;
    },
    updateHospitalInfo(state, item) { // 添加医院相关信息(经纬度,IP地址)
      state.hospitalInfo = item;
    },
    updateUserInfo(state, item) { // 保存用户登陆信息
      state.userInfo = item;
      // console.log(item);
    },
    updateShowOrEditPatientInfo(state, item) {
      state.showOrEditPatientInfo = item;
    },
    updateAllPosition(state, item) { // 所有的GPS
      state.allPosition = item;
    },
    // 增加列表导航栏
    updateVisitedViews(state, item) {
      // 判断是否存在
      const isRepeat = state.visitedViews?.some(e => {
        return e.fullPath === item.fullPath;
      });
      !isRepeat && state.visitedViews?.push(item);
    },
    // 删除一个导航栏
    deleteVisitedViews(state, item) {
      let index;
      state.visitedViews.find((e, i) => {
        if (e.fullPath === item.fullPath) {
          index = i;
        }
      });
      state.visitedViews.splice(index, 1);
    },
  },
  actions: {},
  modules: {},
});
